import React from 'react';
import { Facebook, Instagram, Linkedin, Twitter, Mail, Phone } from 'lucide-react';
import { contactInfo } from '../data/mockData';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_e4fe7836-aa82-4d8f-9622-45c6138206f4/artifacts/912191pk_Logo%20para%20inmobiliaria%20moderno%20azul%20y%20dorado.png" 
              alt="Comfort Home" 
              className="h-28 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 leading-relaxed mb-6">
              {t('footer.tagline')}
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a 
                href={contactInfo.social.facebook}
                className="p-2 rounded-lg bg-gray-800 hover:bg-[#C5A35C] transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href={contactInfo.social.instagram}
                className="p-2 rounded-lg bg-gray-800 hover:bg-[#C5A35C] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href={contactInfo.social.linkedin}
                className="p-2 rounded-lg bg-gray-800 hover:bg-[#C5A35C] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href={contactInfo.social.twitter}
                className="p-2 rounded-lg bg-gray-800 hover:bg-[#C5A35C] transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#C5A35C]">{t('footer.links.title')}</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-[#C5A35C] transition-colors"
                >
                  {t('footer.links.automations')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('benefits')}
                  className="text-gray-400 hover:text-[#C5A35C] transition-colors"
                >
                  {t('footer.links.benefits')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('solutions')}
                  className="text-gray-400 hover:text-[#C5A35C] transition-colors"
                >
                  {t('footer.links.solutions')}
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#C5A35C]">{t('footer.services.title')}</h3>
            <ul className="space-y-3 text-gray-400">
              <li>{t('footer.services.lighting')}</li>
              <li>{t('footer.services.climate')}</li>
              <li>{t('footer.services.security')}</li>
              <li>{t('footer.services.access')}</li>
              <li>{t('footer.services.entertainment')}</li>
              <li>{t('footer.services.voice')}</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#C5A35C]">{t('footer.contact.title')}</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#C5A35C] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-400">{contactInfo.phone}</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#C5A35C] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-400">{contactInfo.email}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Comfort Home. {t('footer.rights')}
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#C5A35C] transition-colors">
                Política de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C5A35C] transition-colors">
                Términos y Condiciones
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
